if (PJQ.app.module === PJQ.constants.modules.APP) {
	PJQ.modules.calendar = {
		routes: [
			{
				route: 'calendar',
				name: 'calendar',
				callback: function () {
					PJQ.app.initNavigator({
						activeItem: "calendar"
					});
				}
			}
		]
	};
	PJQ.app.addRoutes(PJQ.modules.calendar.routes);
}

PJQ.views.calendars = {};

PJQ.views.calendars.MiniCalendar = PJQ.views.BaseView.extend({
	defaults: {
		datepickerOptions: {
			inline: true,
			defaultDate: new Date(),
			format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
			isDaysOnly: true,
			icons: {
				time: 'fal fa-clock',
				date: 'fal fa-calendar-alt',
				up: 'fal fa-chevron-up',
				down: 'fal fa-chevron-down',
				previous: 'fal fa-chevron-left',
				next: 'fal fa-chevron-right',
				today: 'fal fa-crosshairs',
				clear: 'fal fa-trash',
				close: 'fal fa-times'
			}
		},
		onChange: _.noop,
		dateRangeChanged: _.noop
	},
	events: {
		"dp.change": "onChange",
		"dp.update": "onUpdate"
	},
	beforeInit: function (options) {
		this.$el.addClass('mini-calendar');

		if (options.datepickerOptions != null) {
			this.options.datepickerOptions = _.defaults(options.datepickerOptions ? options.datepickerOptions : {}, this.defaults.datepickerOptions);
		}
	},
	afterRender: function () {
		if (PJQ.helpers.objectHelpers.refinedType(this.options.datepickerOptions.defaultDate) === 'date') {
			this.lastSelectedDate = this.options.datepickerOptions.defaultDate;
		}
		this.$el.datetimepicker(this.options.datepickerOptions);
		this.onUpdate();
	},
	onChange: function (e) {
		this.onUpdate();
		if (this.lastSelectedDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(e.date._d, this.lastSelectedDate) !== 0) {
			e.date._d.setHours(0, 0, 0, 0);
			this.lastSelectedDate = e.date._d;
			this.options.onChange(typeof e.date._d === 'undefined' ? null : e.date._d);
			this.renderStatusMarkers();
		}
	},
	updateStatusMarker: function (newStatusDate) {
		if (this.statusDates != null) {
			this.statusDates = _.filter(this.statusDates, function (statusDate) {
				return PJQ.helpers.dateHelpers.getDateDaysDiff(newStatusDate.date, statusDate.date) !== 0;
			});
		}
		else {
			this.statusDates = [];
		}
		this.statusDates.push(newStatusDate);
		this.renderStatusMarker(newStatusDate);
	},
	renderStatusMarkers: function (dates) {
		if (dates != null) {
			this.statusDates = dates;
		}
		//this.$('.status-marker').remove();
		_.each(this.statusDates, function (dayObj) {
			this.renderStatusMarker(dayObj)
		}, this);
	},
	renderStatusMarker: function (statusDate) {
		let dateString = PJQ.helpers.dateHelpers.getDateString(statusDate.date, 'MM/dd/yyyy'),
			$dayContainer = this.$('.day[data-day="' + dateString + '"]');
		if ($dayContainer.hasClass('active')) {
			$dayContainer.css('background-color', statusDate.color);
		}
		if(statusDate.textColor != null) {
			$dayContainer.css('color', statusDate.textColor);
		}
		let $existingMarker = $dayContainer.find('.status-marker');
		if (_.size($existingMarker) > 0) {
			$existingMarker.remove();
		}
		if (statusDate.color != null) {
			let textColor = ''
			if(statusDate.textColor != null) {
				textColor = 'color: ' + statusDate.textColor + ';';
			}
			let $newMarker = $('<span>', {
				class: 'status-marker',
				style: 'background-color: ' + statusDate.color + ';' + textColor
			});
			$newMarker.on('click', function (e) {
				e.stopPropagation();
				$(e.currentTarget).closest('td').trigger('click');
			});
			$dayContainer.append($newMarker);
		}
	},
	onUpdate: function () {
		let currentDateRange = this.getCurrentDateRange(),
			toString = function (date) {
				return PJQ.helpers.dateHelpers.getDateString(date, 'MM/dd/yyyy');
			};
		if (currentDateRange != null && (this.lastDateRange == null || (toString(currentDateRange.start) !== toString(this.lastDateRange.start) || toString(currentDateRange.end) !== toString(this.lastDateRange.end)))) {
			this.lastDateRange = currentDateRange;
			this.options.dateRangeChanged(currentDateRange);
		}
	},
	getCurrentDateRange: function () {
		let $startDayEl = this.$('.datepicker-days').find('td.day').first(),
			$endDayEl = this.$('.datepicker-days').find('td.day').last();
		if (_.size($startDayEl) === 0 || _.size($endDayEl) === 0) {
			return null;
		}
		return {
			start: new Date($startDayEl.data('day')),
			end: new Date($endDayEl.data('day'))
		};
	},
	setDate: function (date) {
		this.lastSelectedDate = date;
		this.$el.data("DateTimePicker").date(date);
		this.renderStatusMarkers();
		this.onUpdate();
	}
});

PJQ.views.calendars.FullCalendar = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Calendar-Base'),
		subTemplates: {
			taskTooltip: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Task-Tooltip')
		},
		canEdit: true,
		canDelete: true,
		onTaskEdit: null,
		onTaskDelete: null,
		fetchTasks: null
	},
	events: {
		'click .btn-edit-task': 'editTaskClicked',
		'click .btn-delete-task': 'deleteTaskClicked',
		'click .btn-close-tooltip': 'closeEventTooltip',
		'contextmenu .fc-day-grid-event': 'eventRightClicked'
	},
	afterRender: function () {
		this.initCalendar();
	},
	initCalendar: function () {
		let fnParseTasks = function (tasks) {
			return _.map(tasks, function (task) {
				return _.defaults({
					extendedProps: {
						model: task.model ? task.model : task,
						progress: task.get('progress') != null ? task.get('progress') : task
					},
					title: task.get('isMilestone') ? ('<span class="far fa-flag mr-1"></span>' + task.get('title')) : task.get('title'),
				}, task.attributes);
			});
		};

		this.calendar = new FullCalendar.Calendar(this.$('.calendar-outer')[0], _.defaults(this.options, {
			height: 'parent',
			plugins: ['dayGrid', 'bootstrap'],
			themeSystem: 'bootstrap',
			defaultView: 'dayGridMonth',
			timezone: 'local',
			header: {
				left: '',
				center: 'title',
				right: 'today prev,next'
			},
			events: typeof this.options.fetchTasks === 'function' ? _.bind(function (filter, callback) {
				this.options.fetchTasks(filter, _.bind(function (res) {
					this.collection = res;
					callback(fnParseTasks(this.collection.models));
				}, this));
			}, this) : fnParseTasks(this.collection.models),
			eventRender: _.bind(this.eventRender, this)
		}));
		this.calendar.render();
	},
	eventRightClicked: function (e) {
		$(e.currentTarget).trigger('click');
		e.preventDefault();
	},
	eventRender: function (info) {
		this.addEventTooltip(info);

		let $ev = $(info.el);
		$ev.addClass('schedule-event');
		if (info.event.id != null) {
			$ev.attr('data-id', info.event.id);
			$ev.attr('title', info.event.title);

			if (typeof this.options.onTaskEdit === 'function') {
				$ev.bind('dblclick', _.bind(function () {
					this.options.onTaskEdit(this.getTask(info.event.id));
				}, this));
			}
		}
	},
	addEventTooltip: function (info) {
		this.tooltip = new PJQ.Tooltip($(info.el), {
			template: this.options.subTemplates.taskTooltip,
			container: this.$el,
			trigger: 'click',
			renderData: _.bind(function () {
				return {
					model: info.event.extendedProps.model,
					schedule: this.options.schedule,
				};
			}, this)
		});
	},
	getTask: function (taskId) {
		let calTask = this.collection.get(taskId);
		return calTask.model ? calTask.model : calTask;
	},
	editTaskClicked: function (e) {
		let taskId = $(e.currentTarget).closest('.task-popup').data('taskId');
		this.editTask(this.getTask(taskId));
	},
	editTask: function (task) {
		if (typeof this.options.onTaskEdit === 'function') {
			this.options.onTaskEdit(task);
		}
	},
	deleteTaskClicked: function (e) {
		let taskId = $(e.currentTarget).closest('.task-popup').data('taskId');
		this.deleteTask(this.getTask(taskId));
	},
	deleteTask: function (task) {
		if (typeof this.options.onTaskDelete === 'function') {
			this.options.onTaskDelete(task);
		}
	},
	closeEventTooltip: function () {
		if (this.tooltip != null) {
			this.tooltip.remove();
			this.tooltip = null;
		}
	}
});

PJQ.views.calendars.SystemCalendar = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'System-Calendar')
	},
	events: {
		'click .btn-add-task': 'addTaskClicked',
		'click .btn-add-milestone': 'addMilestoneClicked',
		'click .btn-export': 'exportCalendar',
		'click .btn-calendar-settings': 'editSettings'
	},
	beforeFirstRender: function () {
		PJQ.app.session.fetchProjectCustomFields(null, _.bind(function (customFields) {
			this.projectCustomFields = customFields;
			PJQ.app.session.fetchScheduleStatuses(_.bind(function (statuses) {
				this.taskStatuses = statuses;
				PJQ.app.session.fetchCalendarSettings(_.bind(function (stResult) {
					this.settings = stResult;
					this.render();
				}, this));
			}, this));
		}, this));
	},
	renderData: function () {
		return {
			settings: this.settings
		};
	},
	afterRender: function () {
		if (this.settings != null) {
			this.calendar = new PJQ.views.calendars.FullCalendar({
				el: this.$('.system-calendar'),
				fetchTasks: _.bind(this.fetchTasks, this),
				onTaskEdit: _.bind(function (task) {
					this.editTask(task);
				}, this),
				onTaskDelete: _.bind(function (task) {
					this.deleteTaskClicked(task);
				}, this),
				canDelete: false
			});
		}
	},
	fetchTasks: function (filter, callback) {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'calendar'
			}
		], [
			{
				parameter: 'start',
				value: PJQ.helpers.dateHelpers.getDateString(new Date(filter.start), 'yyyy-MM-dd')
			},
			{
				parameter: 'finish',
				value: PJQ.helpers.dateHelpers.getDateString(new Date(filter.end), 'yyyy-MM-dd')
			},
			{
				parameter: 'bidsDue',
				value: this.settings.get('bidsDueFilter')
			},
			{
				parameter: 'startFinish',
				value: this.settings.get('startFinishFilter')
			},
			{
				parameter: 'tasks',
				value: this.settings.get('scheduleTasksFilter')
			},
			{
				parameter: 'cfProjects',
				value: this.settings.get('customFieldProjectsFilter')
			},
			{
				parameter: 'cfFilter',
				value: this.settings.get('customFieldIdsFilter')
			},
			{
				parameter: 'cfDisplay',
				value: this.settings.get('customFieldIdsDisplay')
			},
			{
				parameter: 'statusFilter',
				value: this.settings.get('projectStatusFilter')
			}
		]);

		new PJQ.ajax.Request({
			endpoint: endpoint
		}).get().done(_.bind(function (response) {
			this.collection = new PJQ.collections.calendars.CalendarTasks();

			let sysTasks = new PJQ.collections.schedule.Tasks(response.tasks);
			_.each(sysTasks.models, function (sysTask) {
				let status = this.taskStatuses.get(sysTask.get('statusId'));
				if (status == null) {
					status = this.taskStatuses.getDefault();
				}
				sysTask.status = status;

				let calTask = sysTask.getCalendarTask(),
					taskName = sysTask.get('userId') > 0 ? sysTask.get('name') : sysTask.get('name') + ' - ' + sysTask.get('projectName');
				calTask.set('title', taskName);
				this.collection.add(calTask);
			}, this);

			_.each(response.events, function (task) {
				let taskName = task.name + ' - ' + task.projectName;
				if (_.size(this.settings.get('customFieldIdsDisplay')) > 0) {
					_.each(this.settings.get('customFieldIdsDisplay'), function (cfId) {
						let cfValueMatch = _.find(task.customFields, function (cf) {
							return cf.id === cfId;
						});
						if (cfValueMatch != null) {
							let cfMatch = this.projectCustomFields.get(cfId);
							if (cfMatch != null) {
								let cfValue = '';
								if (cfMatch.get('fieldType') === 'DATE') {
									if (_.size(cfValueMatch.value) > 0) {
										cfValue = PJQ.helpers.dateHelpers.getDateString(new Date(cfValueMatch.value), 'MM-dd-yyyy', true);
									}
									else {
										cfValue = 'Not set';
									}

									taskName += '<br /><strong>' + cfMatch.get('fieldName') + "</strong>: " + cfValue;
								}
								else if (cfMatch.get('fieldType') === 'DATETIME') {
									if (_.size(cfValueMatch.value) > 0) {
										cfValue = PJQ.helpers.dateHelpers.getDateString(new Date(cfValueMatch.value), 'MM-dd-yyyy hh:mm:ss');
									}
									else {
										cfValue = 'Not set';
									}

									taskName += '<br /><strong>' + cfMatch.get('fieldName') + "</strong>: " + cfValue;
								}
								else {
									if (_.size(cfValueMatch.value) > 0) {
										cfValue = cfValueMatch.value;
									}
									taskName += '<br /><strong>' + cfMatch.get('fieldName') + "</strong>: " + cfValue;
								}
							}
						}
					}, this);
				}

				let finish = PJQ.helpers.dateHelpers.parseDateString(task.finish ? task.finish : task.start, !task.isAllDay),
					event = new PJQ.models.calendars.CalendarTask({
						id: -_.uniqueId(),
						name: task.name,
						projectId: task.projectId,
						projectName: task.projectName,
						title: taskName,
						start: PJQ.helpers.dateHelpers.parseDateString(task.start, !task.isAllDay),
						finish: task.finish ? finish : null,
						end: finish,
						allDay: task.isAllDay,
						isAllDay: task.isAllDay,
						backgroundColor: task.color != null ? task.color + ' !important' : '#5E35B1 !important',
						borderColor: task.color != null ? task.color + ' !important' : '#5E35B1 !important'
					});
				this.collection.add(event);
			}, this);
			callback(this.collection);
		}, this));
	},
	addTaskClicked: function () {
		let newTask = new PJQ.models.schedule.Task({
			name: "",
			duration: 1,
			start: null,
			finish: null,
			weekendWork: false,
			isAllDay: true,
			isMilestone: false,
			percentComplete: 0,
			notes: "",
			status: this.taskStatuses.getDefault()
		});
		this.editTask(newTask);
	},
	addMilestoneClicked: function () {
		let newTask = new PJQ.models.schedule.Task({
			name: "",
			duration: 1,
			start: null,
			finish: null,
			weekendWork: false,
			isAllDay: true,
			isMilestone: true,
			percentComplete: 0,
			notes: "",
			status: this.taskStatuses.getDefault()
		});
		this.editTask(newTask);
	},
	editTask: function (task) {
		if (task.id > 0 || task.isNew()) {
			// if this is a new task, global calendar task, or project task in the context of a project schedule then we can edit it here
			if (this.model != null || task.isNew() || task.get('projectId') == null) {
				if (!task.isNew()) {
					task.fetch({
						success: _.bind(function () {
							new PJQ.views.schedule.EditTaskModal({
								schedule: this.model,
								model: task,
								statuses: this.taskStatuses,
								onSave: _.bind(function () {
									this.render()
								}, this),
								onDelete: _.bind(function () {
									this.deleteTask(task);
								}, this)
							});
						}, this)
					})
				}
				else {
					new PJQ.views.schedule.EditTaskModal({
						schedule: this.model,
						model: task,
						statuses: this.taskStatuses,
						onSave: _.bind(function (task) {
							this.render();
						}, this),
						onDelete: _.bind(function () {
							this.deleteTask(task);
						}, this)
					});
				}
			}
			else {
				PJQ.app.router.navigate('projects/' + task.get('projectId').toString() + '/schedule/' + task.id.toString(), {
					trigger: true
				});
			}
		}
		else {
			PJQ.app.router.navigate('projects/' + task.get('projectId').toString(), {
				trigger: true
			});
		}
	},
	deleteTaskClicked: function (task) {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this task?",
			onDelete: _.bind(function () {
				this.deleteTask(task);
			}, this)
		});
	},
	deleteTask: function (task) {
		this.collection.remove(task);
		task.destroy({
			success: _.bind(function () {
				this.render()
			}, this)
		});
	},
	exportCalendar: function () {
		let loader = new PJQ.Loader(this.$('.btn-export'), {
			type: 'button',
			loadingText: 'Exporting'
		});
		new PJQ.models.reporting.Report({
			name: 'system-calendar',
			fileName: 'Calendar'
		}).generate({
			html: this.calendar.$el.find('.calendar-outer').outerHTML()
		}, function () {
			loader.remove();
		});
	},
	editSettings: function () {
		new PJQ.views.calendars.CalendarSettingsModal({
			model: this.settings,
			onSave: _.bind(function () {
				this.render();
			}, this)
		});
	}
});

PJQ.views.calendars.CalendarSettingsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Calendar-Settings'),
		onSave: null
	},
	events: {
		'click .btn-save': 'save'
	},
	beforeModalCreated: function () {
		let fnFetch = _.bind(function () {
			PJQ.app.session.fetchProjectCustomFields(null, _.bind(function (cfs) {
				this.customFields = cfs
				PJQ.app.session.fetchProjectStatuses(_.bind(function (statuses) {
					this.projectStatuses = statuses;
					this.render();
				}, this));
			}, this));
		}, this);
		if (this.model == null) {
			PJQ.app.session.fetchCalendarSettings(_.bind(function (settings) {
				this.model = settings;
				fnFetch();
			}, this));
		}
		else {
			fnFetch();
		}
	},
	renderData: function () {
		return {
			projectStatuses: this.projectStatuses,
			customFields: _.filter(this.customFields.models, function (cf) {
				let fieldType = cf.get('fieldType').toUpperCase();
				return fieldType === 'TEXT' || fieldType === 'INT';
			}),
			dateCustomFields: _.filter(this.customFields.models, function (cf) {
				let fieldType = cf.get('fieldType').toUpperCase();
				return fieldType === 'DATE' || fieldType === 'DATETIME';
			})
		}
	},
	afterRender: function () {
		if (typeof this.customFields !== 'undefined') {
			new PJQ.inputs.Selectpicker({
				el: this.$('.bids-due-filter'),
				defaultValue: this.model.get('bidsDueFilter'),
				onChange: _.bind(function (value) {
					this.model.set('bidsDueFilter', value);
				}, this)
			});

			new PJQ.inputs.Selectpicker({
				el: this.$('.start-finish-filter'),
				defaultValue: this.model.get('startFinishFilter'),
				onChange: _.bind(function (value) {
					this.model.set('startFinishFilter', value);
				}, this)
			});

			new PJQ.inputs.Selectpicker({
				el: this.$('.project-tasks-filter'),
				isMultiple: true,
				defaultValue: this.model.get('scheduleTasksFilter'),
				onChange: _.bind(function (value) {
					this.model.set('scheduleTasksFilter', value);
				}, this)
			});

			if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_STATUS_ID)) {
				new PJQ.inputs.Selectpicker({
					el: this.$('.project-status-filter'),
					defaultValue: this.model.get('projectStatusFilter'),
					isMultiple: true,
					onChange: _.bind(function (value) {
						this.model.set('projectStatusFilter', value);
					}, this)
				});
			}

			let defaultVal = {
				projects: this.model.get('customFieldProjectsFilter'),
				fields: this.model.get('customFieldIdsFilter')
			};
			new PJQ.inputs.Selectpicker({
				el: this.$('.custom-fields-filter'),
				defaultValue: defaultVal,
				isGrouped: true,
				onChange: _.bind(function (value) {
					this.model.set('customFieldIdsFilter', value.fields ? value.fields : null);
					this.model.set('customFieldProjectsFilter', value.projects ? value.projects : 'NONE');
				}, this)
			});

			new PJQ.inputs.Selectpicker({
				el: this.$('.custom-fields-display'),
				defaultValue: this.model.get('customFieldIdsDisplay'),
				isMultiple: true,
				onChange: _.bind(function (value) {
					this.model.set('customFieldIdsDisplay', value);
				}, this)
			});
		}
	},
	save: function () {
		if (this.model.hasChanged()) {
			this.model.save(null, {
				success: _.bind(function () {
					PJQ.notifications.notify.successNotify({
						message: 'Calendar settings saved'
					});
					if (typeof this.options.onSave === 'function') {
						this.options.onSave(this.model);
					}
					this.removeModal();
				}, this)
			});
		}
		else {
			this.removeModal();
		}
	}
});


PJQ.models.calendars = {};
PJQ.models.calendars.CalendarSettings = PJQ.models.BaseModel.extend({
	idAttribute: 'userId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'calendar'
			},
			{
				endpoint: 'settings'
			}
		]);
	}
});

PJQ.models.calendars.CalendarTask = PJQ.models.BaseModel.extend({
	parse: function (model) {
		if (model.model != null) {
			this.model = model.model;
		}

		return model;
	}
});

PJQ.collections.calendars = {};
PJQ.collections.calendars.CalendarTasks = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.calendars.CalendarTask
});
